function initUgcSplides() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-ugc-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var items = el.querySelectorAll('.ugc-content__item');
    if (items.length === 0) return;

    var mobileGap = '10px';
    var mobilePerView = 1.33;
    var mobileSlideWidth = 'calc((100% + ' + mobileGap + ')/' + mobilePerView + ' - ' + mobileGap + ')';

    var slider = new Splide(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: mobileGap,
      fixedWidth: mobileSlideWidth,
      pagination: false,
      arrows: false,
      drag: true,
      mediaQuery: 'min',
      breakpoints: {
        992: {
          destroy: true
        },
        0: {
          perPage: 1,
          perMove: 1,
          gap: mobileGap,
          fixedWidth: mobileSlideWidth,
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var prevBtn = el.querySelector('.js-ugc-prev');
    var nextBtn = el.querySelector('.js-ugc-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.go('<');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.go('>');
      });
    }

    var bar = el.querySelector('.js-ugc-progress-bar');

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;

      var index = Math.min(Math.max(slider.index, 0), end);

      if (bar) {
        var rate = Math.min((index + 1) / (end + 1), 1);
        bar.style.width = String(100 * rate) + '%';
      }
      if (prevBtn) {
        prevBtn.disabled = index <= 0;
      }
      if (nextBtn) {
        nextBtn.disabled = index >= end;
      }
    }

    slider.on('mounted move moved updated refresh resized scrolled', syncControls);
    slider.mount();
    el.classList.add('is-initialized');
  });
}

function initUgcVideos() {
  var cards = document.querySelectorAll('.ugc-content__media-card');
  cards.forEach(function (card) {
    if (card.dataset.ugcVideoInitialized === 'true') return;
    card.dataset.ugcVideoInitialized = 'true';

    var videos = card.querySelectorAll('.js-ugc-video');
    var controls = card.querySelector('.js-ugc-video-controls');
    var playPauseBtn = card.querySelector('.js-ugc-play-pause');
    var audioToggleBtn = card.querySelector('.js-ugc-audio-toggle');

    if (videos.length === 0) return;

    if (controls) {
      controls.style.display = 'flex';
    }

    videos.forEach(function (video) {
      video.muted = true;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Auto-play was prevented
        });
      }
    });

    if (playPauseBtn) {
      var iconPause = playPauseBtn.querySelector('.ugc-content__icon--pause');
      var iconPlay = playPauseBtn.querySelector('.ugc-content__icon--play');

      playPauseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var anyPlaying = false;
        videos.forEach(function (v) {
          if (!v.paused) anyPlaying = true;
        });

        if (anyPlaying) {
          videos.forEach(function (v) { v.pause(); });
          if (iconPause) iconPause.style.display = 'none';
          if (iconPlay) iconPlay.style.display = 'inline-flex';
        } else {
          videos.forEach(function (v) { v.play(); });
          if (iconPause) iconPause.style.display = 'inline-flex';
          if (iconPlay) iconPlay.style.display = 'none';
        }
      });
    }

    if (audioToggleBtn) {
      var iconMute = audioToggleBtn.querySelector('.ugc-content__icon--mute');
      var iconUnmute = audioToggleBtn.querySelector('.ugc-content__icon--unmute');

      audioToggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var anyMuted = false;
        videos.forEach(function (v) {
          if (v.muted) anyMuted = true;
        });

        if (anyMuted) {
          videos.forEach(function (v) { v.muted = false; });
          if (iconMute) iconMute.style.display = 'none';
          if (iconUnmute) iconUnmute.style.display = 'inline-flex';
        } else {
          videos.forEach(function (v) { v.muted = true; });
          if (iconMute) iconMute.style.display = 'inline-flex';
          if (iconUnmute) iconUnmute.style.display = 'none';
        }
      });
    }
  });
}

function initUgcContent() {
  initUgcSplides();
  initUgcVideos();
}

document.addEventListener('DOMContentLoaded', initUgcContent);
window.addEventListener('load', initUgcContent);
document.addEventListener('shopify:section:load', initUgcContent);

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.js-ugc-splide') || node.querySelector('.js-ugc-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initUgcContent();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
